<template>
    <div>
        <div class="container-fluid">
            <div class="row content-body justify-content-center">
                <div class="col">
                    <div class="container">


                        <div class="text-center mb-5">
                            <div class=" ">
                                <div class="main-title txt-primary">Retirement Checkup</div>
                                <div class="md-headline txt-gray">วางแผน คำนวณเป้าหมายเงินเก็บหลังเกษียณ</div>
                            </div>
                        </div>


                        <md-card>
                            <md-card-header class="background-primary">
                                <div>
                                    <div class="md-title">{{retirement.header}}</div>
                                </div>
                            </md-card-header>

                            <md-card-content>

                                <div class="row justify-content-center">
                                    <div class="col-auto">
                                        <div class="step">
                                            <hr class="dot-line">
                                            <span class="dot"
                                                  v-bind:class="{ active: retirement.mainStepActive >= 1}">
                                                1
                                            </span>
                                            <span class="dot"
                                                  v-bind:class="{ active: retirement.mainStepActive >= 2 }">
                                                2
                                            </span>
                                            <span class="dot"
                                                  v-bind:class="{ active: retirement.mainStepActive >= 3 }">
                                                3
                                            </span>
                                            <span class="dot"
                                                  v-bind:class="{ active: retirement.mainStepActive >= 4 }">
                                                4
                                            </span>
                                        </div>
                                    </div>
                                </div>


                                <transition name="slide-fade">
                                    <div class="stepper-content" v-if="retirement.mainStepActive === 1">
                                        <stepper-first></stepper-first>
                                    </div>
                                </transition>


                                <transition name="slide-fade">
                                    <div class="stepper-content" v-if="retirement.mainStepActive === 2">
                                        <stepper-second></stepper-second>
                                    </div>
                                </transition>


                                <transition name="slide-fade">
                                    <div class="stepper-content" v-if="retirement.mainStepActive === 3">
                                        <stepper-third></stepper-third>
                                    </div>
                                </transition>


                                <transition name="slide-fade">
                                    <div class="result" v-if="retirement.mainStepActive === 4">
                                        <stepper-fourth></stepper-fourth>
                                    </div>
                                </transition>

                            </md-card-content>
                        </md-card>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import StepperFirst from "../components/stepperFirst";
    import StepperSecond from "../components/stepperSecond";
    import StepperThird from "../components/stepperThird";
    import {mapState} from 'vuex';
    import StepperFourth from "../components/stepperFourth";

    import store from '../store';
    import {
        SET_STEPPER_DATA,
        GET_RESULT_RETIREMENT_PLAN,
        GET_RESULT_FROM_CHATBOT,
        SET_ACTIVE
    } from '../store/actions.type'

    import {retirementService} from '../services/retirement'

    export default {
        name: 'RetirementCheckUp',
        components: {StepperFourth, StepperThird, StepperSecond, StepperFirst,},
        computed: mapState({
            retirement: state => state.retirement
        }),
        async created() {

            let params = this.$route.query;
            let obj = {};

            if (params.employee) {
                obj.employee = params.employee;
            }

            if (params.employee) {
                obj.employer = params.employer;
            }

            if (params.employee) {
                obj.planPVD = params.pvd_plan;
            }

            if (params.employee) {
                obj.pvdRate1 = params.pvd_eq_value;
            }

            store.dispatch(SET_STEPPER_DATA, {key: 'third', data: obj});

            if (params.uid) {
                let result = await store.dispatch(GET_RESULT_RETIREMENT_PLAN, params.uid);

                if (params.step === '4') {
                    let resultObj = await store.dispatch(GET_RESULT_FROM_CHATBOT, result);

                    store.dispatch(SET_STEPPER_DATA, {key: 'params', data: resultObj});

                    let calculatePromise = retirementService.calculate(resultObj);
                    let suggestionPromise = retirementService.getSuggestion(resultObj);

                    let [calculation, suggestion] = await Promise.all([calculatePromise, suggestionPromise]);

                    store.dispatch(SET_STEPPER_DATA, {key: 'result', data: calculation});
                    store.dispatch(SET_STEPPER_DATA, {key: 'suggestion', data: suggestion.data ? suggestion.data : []});

                    store.dispatch(SET_ACTIVE, 4);
                }
            }

        }
    }
</script>


<style lang="scss" scoped>
    @import "../assets/css/colors";

    .content-body {
        background-image: url("../assets/images/bg.png");
        background-color: $smoke;
    }

    .dot {
        height: 35px;
        width: 35px;
        background-color: $smoke;
        border-radius: 50%;
        display: inline-block;
        margin: 0 15px;
        text-align: center;
        font-size: 20px;
        padding-top: 7px;
    }

    .dot.active {
        background-color: $warning;
    }

    .dot-line {
        margin-bottom: -17.5px;
        width: calc(100% - 30px);
    }

    .step {
        margin-bottom: 50px;
    }

    .md-card {
        border-radius: 8px;
    }

    .md-card-header {
        border-radius: 8px 8px 0 0;
    }

    .main-title {
        font-size: 55px;
        line-height: 1.2;
    }

    .stepper-content, .result {
        font-size: 22px;
    }

    @media only screen and (max-width: 578px) {
        .content-body .container {
            padding: 0;
        }

        .main-title {
            font-size: 45px;
        }
    }

    @media only screen and (min-width: 768px) {
        .stepper-content {
            padding-right: 80px;
            padding-left: 80px;
        }
    }


</style>

